import { ChangeEvent, ReactNode } from 'react';
import { parseHtml } from './parseHtml';

interface CheckboxProps {
    className?: string;
    children?: ReactNode;
    inputClassName?: string;
    name?: string;
    id?: string;
    label?: string;
    value?: string;
    checked?: boolean;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    tabIndex?: number;
    disabled?: boolean;
    testId?: string;
}

export function Checkbox(props: CheckboxProps) {
    const { name, label, onChange, value, checked, id, className, tabIndex, disabled, inputClassName, testId } = props;
    return (
        <label className={`custom-control custom-checkbox ${className ?? ''}`}>
            <input
                id={id ?? name}
                type="checkbox"
                name={name}
                onChange={onChange}
                checked={checked ?? false}
                disabled={disabled}
                value={value ?? ''}
                className={`custom-control-input ${inputClassName ?? ''}`}
                tabIndex={tabIndex}
                data-testid={testId ?? id}
            />
            <span className="custom-control-label">{(label && <>{parseHtml(label)}</>) ?? props.children}</span>
        </label>
    );
}
